/* 
	Driver for GSS Sensors controller

 	Manufacturer: Scottish technology firm Gas Sensing Solutions (GSS)
 	Homepage: https://www.gassensing.co.uk/

	TODO: rename to gss.js
*/

import Serial	from "serial";

class GSS {
  static constructor() {
    GSS.MODE_COMMAND = 0;
    GSS.MODE_STREAMING = 1;
    GSS.MODE_POLLING = 2;
  }
  constructor() {
  }
  open(path) {
    return( new Promise(function(resolve, reject) {
      var serial = new Serial();

      serial.onerror = function(event) {
        reject(event.message);
      }.bind(this);

      serial.onsuccess = function(event) {
        serial.onsuccess = function(event) {
          resolve(true);
        }.bind(this);
        serial.flush();
      }.bind(this);

      serial.open(path, {
        baudrate: 9600,
        databits: 8,
        parity: "none",
        stopbits: 1
      });

      this.__serial = serial;
    }.bind(this)) );
  }
  close() {
    return( new Promise(function(resolve, reject) {
      this.__serial.onerror = function(event) {
        reject(event.message);
      }.bind(this);
      this.__serial.onsuccess = function(event) {
        resolve(true);
      }.bind(this);
      this.__serial.close();
    }.bind(this)) );
  }
  command(cmd) {
    return( new Promise(function(resolve, reject) {
      var message = "";
      this.__serial.onmessage = function(event) {
        var uint8Array = new Uint8Array(event.data);
        var str = new TextDecoder("utf-8").decode( uint8Array );
        message += str;
        if (message.endsWith("\r\n")) {
          message = message.replace("\r\n", "");
          message = message.replace(" ", "");
          message = message.replace(cmd, "");
          resolve(message);
        }
      }.bind(this)
      this.__serial.send(cmd+"\r\n");
    }.bind(this)) );
  }
  async getDeviceInformation() {
    return await this.command("Y");
  }
  async setOperatingMode(mode) {
    return await this.command(`K ${mode}`);
  }
  async setDigitalFilter(n) {
    return await this.command(`A ${n}`);
  }
  async getDigitalFilter() {
    return parseInt( await this.command("a") );
  }
  async getFilteredGasConcentration() {
    var multiplier = await this.command(".");
    var co2 = await this.command("Z");
    return multiplier * co2;
  }
  async getTemperature() {
    var t = await this.command("T");
    t = t-1000;
    t = t/10;
    return t;
  }
  async getRelativeHumidity() {
    var h = await this.command("H");
    return h/10;
  }
  async zeroCalibrateIn0ppm() {
    return await this.command("U");
  }
  /* Fresh Air meas 400ppm by default */
  async zeroCalibrateInFreshAir() {
    return await this.command("G");
  }
  async zeroCalibrateIn(ppm) {
    /*
      For example, if the user wants to zero the sensor in a known concentration of gas (e.g. 450ppm), the
      value written to the sensor must be 450/scaling factor.
    */
    var multiplier = await this.command(".");
    ppm /= multiplier;
    ppm = Math.round(ppm);
    return await this.command(`X ${ppm}`);
  }
}

GSS.constructor();

export default GSS;